<template>
  <div class="client-source-select" v-if="showSelectBlock">
    <div class="d-flex align-center">
      <div class="info-icon">
        !
      </div>
      <v-select
        v-model="selectedSource"
        @change="changeSourceSelect"
        :items="sources"
        item-text="name"
        item-value="id"
        hide-details="auto"
        class="select"
        background-color="#e6f2e6"
        placeholder="Выберите источник клиента..."
        flat
        label="Новый клиент"
        :loading="isLoading"
        :disabled="isLoading"
      />
    </div>
    <transition name="slide">
      <div v-if="showCustomInput" class="custom-name">
        <v-text-field
          height="41px"
          v-model="customName"
          hide-details="auto"
          class="text-field"
          flat
          solo
          @input="showSaveBtn=true"
          :disabled="isLoading"
        />
        <v-btn
          v-if="showSaveBtn && customName"
          block
          class="button-save"
          color="#4CAF50"
          depressed
          :loading="isLoading"
          @click="saveSource"
        >
          Сохранить
        </v-btn>
      </div>
    </transition>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import SnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'ClientSourceSelect',
    mixins: [SnackbarMessage],
    props: {
      action: {
        type: String,
        default: 'edit-order',
      },
    },
    data () {
      return {
        isLoading: false,
        showSelect: false,
        selectedSource: 0,
        customName: '',
        showSaveBtn: false,
        sources: [],
      }
    },
    watch: {
      showCustomInput (newValue) {
        if (!newValue) {
          this.showSaveBtn = false
        }
      },
      showSelectBlock (newValue) {
        if (newValue && !this.showSelect) {
          this.showSelect = true
          this.loadSourcesList()
        }
        this.$emit('setRequiredStatus', newValue)
      },
    },
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
        currentEditOrder: state => state.orders.currentEditOrder,
      }),
      ...mapGetters({
        isSourceAggregator: 'baskets/isSourceAggregator',
      }),
      showSelectBlock () {
        return (this.needSetClientSource || this.showSelect) && !this.isSourceAggregator
      },
      isNewClient () {
        if (this.action === 'new-order') {
          return this.basket.client && !this.basket.client.firstCompletedOrderId
        } else {
          return this.currentEditOrder &&
            this.currentEditOrder.client &&
            !this.currentEditOrder.client.firstCompletedOrderId
        }
      },
      clientNoHasSource () {
        return this.basket && this.basket.client && !this.basket.client.registrationMarketingSource
      },
      editedOrderId () {
        return (this.action !== 'new-order') ? this.currentEditOrder?.id : null
      },
      needSetClientSource () {
        return false
        // this.isNewClient && this.clientNoHasSource
      },
      selectedSourceItem () {
        return this.sources.find((item) => item.id === this.selectedSource)
      },
      showCustomInput () {
        return this.selectedSourceItem && this.selectedSourceItem?.custom
      },
    },
    methods: {
      loadSourcesList () {
        this.isLoading = true
        this.$store.dispatch('marketing/fetchMarketingSourcesList')
          .then((res) => {
            this.sources = res
          })
          .catch((e) => {
            this.showErrorFromResponse(e)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      changeSourceSelect () {
        if (!this.selectedSourceItem?.custom) {
          this.saveSource()
        }
      },
      saveSource () {
        this.isLoading = true

        const data = {
          marketingSourceId: this.selectedSource,
          orderId: this.editedOrderId,
          customName: this.customName,
        }

        const id = this.basket.id

        this.$store
          .dispatch('baskets/updateClientRegistrationSource', { data, id })
          .then(() => {
            this.showSaveBtn = false
            this.showSuccessMessage('Источник клиента сохранен')
          })
          .catch((err) => {
            this.showErrorFromResponse(err)
            this.selectedSource = null
          })
          .finally(() => { this.isLoading = false })
      },

    },
  }
</script>

<style lang="less" scoped>
.client-source-select {
  padding: 0.85em 0.92em;
  margin-bottom: 12px;
  background-color: #e6f2e6;
  border-radius: 10px;
  font-size: 12px;

  .media-xl({
    font-size: 14px;
  });

  .info-icon {
    font-size: 2.14em;
    width: 1.67em;
    min-width: 1.67em !important;
    height: 1.67em;
    color: #FFF;
    background: #e91e63;
    border-radius: 4px;
    text-align: center;
    line-height: 1.67em;
    font-weight: bold;
    margin-right: 15px;
    .media-xl({
      margin-right: 20px;
    });
  }
  ::v-deep {
    input {
      .media-xl-max({
        font-size: 14px;
      });
    }
    .v-select__slot {
      .v-label {
        color: #e91e63 !important;
      }
    }
    .theme--light.v-text-field > .v-input__control > .v-input__slot:before,
    .v-text-field > .v-input__control > .v-input__slot:after {
      border-color: transparent !important;
    }

    .v-list-item__title {
      font-size: 1.14em;
    }
  }

  .v-select {
    font-size: 1.14em;
  }

  .custom-name {
    padding-top: 10px;
    .text-field {
      margin-bottom: 10px;
      font-size: 1em;
    }
    ::v-deep {
      .v-text-field.v-text-field--solo .v-input__control {
        min-height: 41px;
      }
      input {
        font-size: 1.14em
      }
    }
  }
}
</style>
